import { render, staticRenderFns } from "./PermanentKey.vue?vue&type=template&id=2342226d"
import script from "./PermanentKey.vue?vue&type=script&lang=js"
export * from "./PermanentKey.vue?vue&type=script&lang=js"
import style0 from "./PermanentKey.vue?vue&type=style&index=0&id=2342226d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports